export enum EventType {
    IMPRESSION = "impression",
    DISMISS = "dismiss",
    CLICK = "click",
}
